import { render, staticRenderFns } from "./Recommend06.vue?vue&type=template&id=11412f4e&"
import script from "./Recommend06.vue?vue&type=script&lang=js&"
export * from "./Recommend06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports